import styled from "styled-components";

import { BTTO_PROFILE_COLORS } from "../../shared/elements";

export const BettoInboxRoot = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const BettoInboxContentCard = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
	padding: 16px;
	border-radius: 12px;
	background: ${BTTO_PROFILE_COLORS.surface};
	border: 1px solid ${BTTO_PROFILE_COLORS.border};
	overflow: hidden;

	@media (min-width: 768px) {
		padding: 20px;
	}
`;

export const BettoInboxTitle = styled.h1`
	margin: 0;
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 18px;
	font-weight: 700;
	line-height: 1.2;

	@media (min-width: 768px) {
		font-size: 20px;
	}
`;

export const BettoInboxMarkAllButton = styled.button`
	display: block;
	width: 100%;
	padding: 8px 12px;
	border: 0.6px solid #2b3245;
	border-radius: 8px;
	background: transparent;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	font-weight: 500;
	line-height: 1.4;
	text-align: center;
	cursor: pointer;
	transition:
		color 0.2s ease,
		border-color 0.2s ease;

	&:hover {
		color: ${BTTO_PROFILE_COLORS.text};
		border-color: ${BTTO_PROFILE_COLORS.borderActive};
	}
`;

export const BettoInboxList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const BettoInboxCard = styled.article`
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding: 12px 0;
	border: 0.6px solid
		${({ $isUnread }) =>
			$isUnread ? BTTO_PROFILE_COLORS.borderActive : BTTO_PROFILE_COLORS.border};
	border-radius: 12px;
	background: ${BTTO_PROFILE_COLORS.surfaceRaised};
	cursor: pointer;
`;

export const BettoInboxCardContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	padding: 0 12px;
`;

export const BettoInboxTitleRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	min-width: 0;
`;

export const BettoInboxTitleGroup = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 8px;
	flex: 1 1 auto;
	min-width: 0;
`;

export const BettoInboxUnreadDot = styled.span`
	flex-shrink: 0;
	width: 8px;
	height: 8px;
	margin-top: 5px;
	border-radius: 50%;
	background: ${BTTO_PROFILE_COLORS.borderActive};
`;

export const BettoInboxCardTitle = styled.h3`
	margin: 0;
	flex: 1 1 auto;
	min-width: 0;
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 14px;
	font-weight: 600;
	line-height: 1.4;
`;

export const BettoInboxPreview = styled.p`
	margin: 0;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	line-height: 1.3;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
`;

export const BettoInboxMessage = styled.div`
	padding: 0 12px;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	line-height: 1.45;

	a {
		color: ${BTTO_PROFILE_COLORS.borderActive};
	}
`;

export const BettoInboxFooter = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding-right: 12px;
`;

export const BettoInboxCardActions = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	flex-shrink: 0;
`;

export const BettoInboxIconButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	padding: 0;
	border: none;
	border-radius: 8px;
	background: transparent;
	color: ${({ $isUnread }) =>
		$isUnread ? BTTO_PROFILE_COLORS.borderActive : BTTO_PROFILE_COLORS.textMuted};
	cursor: pointer;
	transition:
		color 0.2s ease,
		background 0.2s ease;

	&:hover {
		color: ${BTTO_PROFILE_COLORS.text};
		background: rgba(255, 255, 255, 0.04);
	}
`;

export const BettoInboxMetaGroup = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	padding-left: 12px;
	min-width: 0;
	flex-wrap: wrap;
`;

export const BettoInboxMetaItem = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 5px;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	white-space: nowrap;

	svg {
		flex-shrink: 0;
	}
`;

export const BettoInboxMailButton = BettoInboxIconButton;

export const BettoInboxLoadingRef = styled.div`
	padding: 16px 0;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	text-align: center;
`;

export const BettoCheckboxWrapper = styled.label`
	display: inline-flex;
	align-items: center;
	cursor: pointer;
	user-select: none;
	gap: 8px;
`;

export const BettoCustomCheckbox = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	height: 18px;
	border: 1.5px solid
		${({ $checked }) => ($checked ? BTTO_PROFILE_COLORS.borderActive : "#485370")};
	border-radius: 4px;
	background: ${({ $checked }) => ($checked ? BTTO_PROFILE_COLORS.borderActive : "transparent")};
	transition: all 0.2s ease;
	flex-shrink: 0;

	&:after {
		content: "";
		display: ${({ $checked }) => ($checked ? "block" : "none")};
		width: 4px;
		height: 8px;
		border: solid #ffffff;
		border-width: 0 1.5px 1.5px 0;
		transform: rotate(45deg) translate(-1px, -1px);
	}
`;

export const BettoInboxControlBar = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 12px;
	border: 1px solid ${BTTO_PROFILE_COLORS.border};
	border-radius: 10px;
	background: ${BTTO_PROFILE_COLORS.surfaceRaised};
`;

export const BettoInboxControlActions = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	flex: 1 1 auto;
	min-width: 0;
`;

export const BettoInboxSelectedCount = styled.span`
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	font-weight: 400;
`;

export const BettoInboxBulkButton = styled.button`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 6px 12px;
	border: 0.6px solid #2b3245;
	border-radius: 8px;
	background: transparent;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	font-weight: 500;
	cursor: pointer;
	transition:
		color 0.2s ease,
		border-color 0.2s ease,
		background-color 0.2s ease;

	&:hover {
		color: ${BTTO_PROFILE_COLORS.text};
		border-color: ${BTTO_PROFILE_COLORS.borderActive};
		background: rgba(255, 255, 255, 0.02);
	}
`;
